import axios, { InternalAxiosRequestConfig } from 'axios';
import { useUserStore } from '../../store/UserStore';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_QW_API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

apiClient.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
        const { isAccessTokenExpired, isRefreshTokenExpired, refreshAccessToken, logout } = useUserStore.getState();

        try {
            if (isAccessTokenExpired() && !isRefreshTokenExpired()) {
                const refreshed = await refreshAccessToken();
                if (refreshed) {
                    config.headers.Authorization = `Bearer ${useUserStore.getState().user.access_token}`;
                    config.headers['Quizzweb-User-Id'] = useUserStore.getState().user.id;
                } else {
                    logout();
                }
            } else {
                config.headers.Authorization = `Bearer ${useUserStore.getState().user.access_token}`;
                config.headers['Quizzweb-User-Id'] = useUserStore.getState().user.id;
            }

            return config;
        } catch (error) {
            console.error('Error in request interceptor:', error);
            logout();
            return Promise.reject(error);
        }
    },
    (error) => Promise.reject(error)
);

export default apiClient;
